<template>
  <div class="news_wrapper w">
    <div
      v-if="componentInfo.config.showTitle"
      class="news_title"
    >
      <new-index-title :title="componentInfo.config.title"></new-index-title>
      <NuxtLink to="/article/list">
        <div
          v-if="componentInfo.config.showMore"
          class="news_title_more pointer"
        >
          更多<i class="arrows" />
        </div>
      </NuxtLink>
    </div>
<!--    <div class="new_main">-->
<!--      <NuxtLink-->
<!--        v-for="item in componentInfo.data"-->
<!--        :key="item.id"-->
<!--        :to="'/article/view?id=' + item.id"-->
<!--        class="news_item_wrapper"-->
<!--      >-->
<!--        <div class="news_item">-->
<!--          <div class="news_info">-->
<!--            <div class="news_name tx-ov-2">-->
<!--              {{ item.title }}-->
<!--            </div>-->
<!--            <div class="news_desc tx-ov-2">-->
<!--              {{ item.summary }}-->
<!--            </div>-->
<!--            <div class="new_info_desc">-->
<!--              <span>{{ item.readCount + "人已阅" }}</span>-->
<!--              <span class="border" />-->
<!--              <span>{{ item.gmtCreate }}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div-->
<!--            v-if="item.cover"-->
<!--            class="item_image_wrapper"-->
<!--          >-->
<!--            <img-->
<!--              class="item_image"-->
<!--              :src="item.cover"-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--      </NuxtLink>-->
<!--    </div>-->

    <div style="display: flex">
      <div class="news-view" @mouseout="mout" @mouseover="mover">
        <ul class="banner-list" style="height: 332px; width: 787px  ">
          <li v-for="(item, index) in bannerList" :key="index" class="item" :class="{ on: index === num }">
            <custom-link :to="handleNavigate(item)" :targetType="1" targetOpenNewPage custom-class="image_wrapper">
              <img class="image" style="width: 787px;height: 332px" :src="item.cover" :alt="item.title" />
              <div class="image-bg">
                <div style="cursor: pointer">
                  <div style="font-size: 20px">
                    [新闻]
                  </div>

                  <div class="title">
                    {{ item.title }}
                  </div>

                  <div class="new_info_desc">
                    {{item.summary}}
                  </div>

                  <div class="time">
                    {{ item.gmtCreate }}
                  </div>
                </div>

              </div>
            </custom-link>
          </li>
        </ul>

        <div class="relative" style="width: 787px">
          <ul class="page_dots">
            <span v-for="(item, index) in bannerList" :key="index" class="dots" :class="{ on: index === num }" @click="num = index" @mouseenter="num = index" />
          </ul>

        </div>

      </div>
      <div class="right-view">
        <NuxtLink v-for="(item, index) in newsList" :key="item.id" :to="handleNavigate(item)">
          <div class="right-item-view">
            <div class="index-view">
              {{index + 1}}
            </div>

            <div style="margin-left: 10px;width: 100%">
              <div class="top">
                <div class="title">{{ item.title }}</div>
                <div class="time">{{ getTime(item) }}</div>
              </div>

              <div class="bottom">
                {{ item.summary }}
              </div>
            </div>
          </div>
        </NuxtLink>

      </div>
    </div>


  </div>
</template>

<script>
import {defineComponent, onMounted, ref, watch} from 'vue'

export default defineComponent({
  props: {
    componentInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const num = ref(0);
    const interval = ref(null);
    const bannerList = ref([]);
    const newsList = ref([])
    watch(
      props.componentInfo,(newV)=>{
        console.log('news = ',newV)
        if (newV.data){
          if (newV.data.length > 3) {
            bannerList.value = newV.data.slice(0,3)
            newsList.value = newV.data.slice(3,newV.data.length)

            console.log('bannerList = ',bannerList.value)
            console.log('newsList = ',newsList.value)
          }else{
            bannerList.value = newV.data
          }
        }
      }
    )

    // watch(
    //   () => data.pwdForm,
    //   () => {
    //     data.noEditPwd = false
    //   },
    //   { deep: true }
    // )
    onMounted(() => {
      change();
    });
    const handleNavigate = (item) => {
      return '/article/view?id=' + item.id
    }

    const getTime = (item) => {
      if (item.gmtCreate){
        let date = new Date(item.gmtCreate)
        let month = date.getMonth() + 1
        let day = date.getDate()
        if (day < 10) {
          day = '0' + day
        }

        return month + '/' + day
      }
      return ''
    }

    const toUrl = (item) => {

    }

    const change = () => {
      interval.value = setInterval(() => {
        if (num.value + 1 >= bannerList.value.length) {
          num.value = 0;
        } else {
          num.value++;
        }
      }, 5000);
    };
    const mout = () => {
      change();
    };
    const mover = () => {
      clearInterval(interval.value);
    };



    return {
      num,
      bannerList,
      newsList,
      mout,
      mover,
      handleNavigate,
      getTime,
    }
  }
})
</script>
<style lang="scss" scoped>
.news_wrapper {
  padding: 25px 0px;
}
.news_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  line-height: 22px;
  color: #333;
}
.news_title_name {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  img {
    width: 24px;
    height: 24px;
  }
}
.new_main {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}
.news_item_wrapper {
  margin-bottom: 20px;
  padding: 0 10px;
  width: 50%;
}
.news_item_wrapper:nth-last-child(-n + 2) {
  margin-bottom: 0;
}
.news_item {
  padding: 15px;
  display: flex;
  background: #ffffff;
  border-radius: 5px;
  &:hover {
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
    transition: all 0.3s;
  }
}
.item_image_wrapper {
  overflow: hidden;
  height: 80px;
  width: 144px;
  border-radius: 6px;
  .item_image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.news_info {
  flex: 1;
  padding-right: 10px;
}
.news_name {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color:#333;
  -webkit-line-clamp: 1;
}
.news_desc {
  padding-top: 5px;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  color: #999999;
}
.new_info_desc {
  font-size: 12px;
  line-height: 18px;
  //white-space: nowrap;
  color: #999999;
  .border {
    background: #becadb;
    display: inline-block;
    height: 10px;
    margin: 0 10px;
    width: 1px;
  }
}

.news-view{
  width: 787px;
  .banner-list{
    width: 787px;
  }
  ul {
    position: relative;
  }
  .item {
    opacity: 0;
    height: 100%;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    transition: all 1s;
    &.on {
      opacity: 1;
      z-index: 10;
    }
    a {
      width: 100%;
      height: 100%;
      display: block;
    }

    .image-bg{
      position: absolute;
      background: linear-gradient(to right, rgba(24,109,192, 1), rgba(24,109,192, 0.48));
      top:0;
      left:0;
      height: 100%;
      width: 100%;
      padding: 48px 43px;
      color: white;

      .title{
        font-size: 20px;
        line-height: 24px;
        margin-top: 34px;
      }

      .new_info_desc{
        margin-top: 15px;
        font-size: 14px;
        color:rgba(255,255,255,1);
        line-height: 22px;
        width: 600px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        //height: 50px;
        //text-overflow: ellipsis;
        //display: -webkit-box;
        //-webkit-line-clamp: 2;
        //word-break: break-all;
        //-webkit-box-orient: vertical;
        //overflow: hidden;
      }

      .time{
        margin-top: 30px;
        font-size: 12px;
        color:rgba(255,255,255,1);
      }
    }
  }
  .page_dots {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 15px;
    left: 25px;
    padding: 0px 15px 0;
    text-align: center;
    border-radius: 13px;
    height: 26px;
    // background: rgba(0, 0, 0, 0.2);
    z-index: 11;
    &.old {
      left: 0;
      right: 0;
      margin-right: 0;
      bottom: 30px;
    }
    .dots {
      display: inline-block;
      width: 8px;
      height: 6px;
      margin: 0 4px;
      background: rgba(255,255,255,0.3);
      border-radius: 15px;
      &.on {
        width: 14px;
        background: white;
      }
    }
  }


}
.right-view{
  width: 413px;
  background: white;
  height: 332px;
  box-sizing: border-box;
  .right-item-view{
    cursor: pointer;
    width: 100%;
    height: 83px;
    padding: 20px;
    display: flex;
    .index-view{
      background: rgba(212,216,223,1);
      color:white;
      height:20px;
      width:20px;
      min-width: 20px;
      text-align: center;
    }

    .top{
      display: flex;
      justify-content: space-between;

      .title{
        width: 260px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        word-break: break-all;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .time{
        color:rgba(153,153,153,1)
      }
    }
    .bottom{
      color:rgba(136,136,136,1);
      margin-top: 5px;
      font-size: 12px;
      width: 320px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      word-break: break-all;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &:hover{
      background: rgba(235,242,247,1);
      border-right: 4px rgba(22,113,218,1) solid;
      .index-view{
        background: rgba(22,113,218,1);
      }
    }
  }
}
</style>
